@if (useDropdown) {
	<button ejs-dropdownbutton [items]="messageTypes" (select)="confirmAppointmentMessage($event)" iconCss="fa fa-comment"
			class="e-primary margin-left-sm margin-bottom-xs"
			revTooltip tooltipContent="Send Appointment Reminder" [disabled]="appointmentStarted"></button>
}
@if (!useDropdown && isEmailable) {
	<button ejs-button [disabled]="appointmentStarted" type="button" iconCss="fa fa-envelope" revTooltip tooltipContent="Send Email Appointment Reminder"
			class="margin-left-sm margin-bottom-xs" [isPrimary]="true" (click)="confirmAppointmentMessage({item: emailComType})"></button>
}
@if (!useDropdown && isTextable) {
	<button ejs-button [disabled]="appointmentStarted" type="button" iconCss="fa fa-commenting" revTooltip tooltipContent="Send Text Appointment Reminder"
			class="margin-left-sm margin-bottom-xs" [isPrimary]="true" (click)="confirmAppointmentMessage({item: textComType})"></button>
}
